<template>
	
<com-section :section="section" v-on:back="$emit('back')" v-on:next="$emit('next')" :intro="section.intro" v-on:introducing="$emit('introducing')" v-on:introduced="$emit('introduced')">

	<slot></slot>

	<portal to="modal">

		<div class="health-modal" v-if="is.video || is.image">

			<div class="health-modal-overlay" v-on:click="onModalClose"></div>

			<div class="health-modal-panel">

				<div class="health-modal-header">

					<div class="health-modal-title"></div>

					<button class="health-modal-close" v-on:click="onModalClose">&times;</button>

				</div>

				<div class="health-modal-body">

					<video-player :options="{
						muted: true,
						loop: true,
						autoplay: true,
						fluid: true,
						sources: {
							type: 'video/mp4',
							src: 'https://www.ifraptool.co.uk/media/spine.b6f8d3e1.mp4'
						}
					}" :playsinline="true" class="video-player-box" ref="videoPlayer" v-if="is.video === 'spine'" />

					<div class="health-modal-image" v-if="is.video === 'bone'">
						<img :src="insideImage" />
					</div>

					<div class="health-modal-skeleton" v-if="is.video === 'skeleton'">
						<div class="health-skeleton">
							<div class="health-skeleton-spot is-arm is-visible"></div>
							<div class="health-skeleton-spot is-wrist is-visible"></div>
							<div class="health-skeleton-spot is-pelvis is-visible"></div>
							<div class="health-skeleton-spot is-hip is-visible is-clickable" :class="{'is-active': spot === 'hip'}" v-on:click="onSpotClick('hip')"></div>
							<div class="health-skeleton-spot is-spine is-visible is-clickable" :class="{'is-active': spot === 'spine'}" v-on:click="onSpotClick('spine')"></div>
						</div>
					</div>

					<div class="health-modal-image" v-if="is.video === 'population'">
						<img :src="populationImage" />
					</div>

					<div class="health-modal-image" v-if="is.image">
						<img :src="is.image" />
					</div>

				</div>

			</div>

		</div>

	</portal>

	<div class="health">

		<div class="health-skeleton" v-if="!$isPatient">

			<div class="health-skeleton-spot is-arm" :class="{'is-visible': step === 2}"></div>
			<div class="health-skeleton-spot is-wrist" :class="{'is-visible': step === 2}"></div>
			<div class="health-skeleton-spot is-pelvis" :class="{'is-visible': step === 2}"></div>
			<div class="health-skeleton-spot is-hip" :class="{'is-visible': step === 2 || step === 3, 'is-clickable': step === 3, 'is-active': spot === 'hip'}" v-on:click="onSpotClick('hip')"></div>
			<div class="health-skeleton-spot is-spine" :class="{'is-visible': step === 2 || step === 3, 'is-clickable': step === 3, 'is-active': spot === 'spine'}" v-on:click="onSpotClick('spine')"></div>

		</div>

		<div class="health-sections" v-if="!$isPatient">

			<com-inside v-on:next="onNext" v-on:back="step = 1" :completed="step > 1" :active="step === 1" :section="section" v-on:video="is.video = 'bone'" />
			<com-chance v-on:next="onNext" v-on:back="step = 2" :completed="step > 2" :active="step === 2" :section="section" />
			<com-effects v-on:next="onNext" v-on:back="step = 3" :spot="spot" :completed="step > 3" :active="step === 3" :section="section" v-on:video="is.video = 'spine'" />

			<com-check v-if="step > 3" v-on:next="$emit('next')" :text="section.proceed" :info="section.proceedInfo" />

		</div>

		<div class="health-sections" v-if="$isPatient">

			<com-generic v-for="(s, index) in patientSteps" :key="s.key" v-on:next="onNext" v-on:back="step = index + 1" :completed="step > index + 1" :active="step === index + 1" :title="s.title" :text="s.text" v-on:media="onMedia($event)" v-on:image="onImage($event)" />


		</div>

	</div>

</com-section>

</template>

<script>

import comSection from '@/components/tool/common/Section'

import comInside from './health/Inside'
import comChance from './health/Chance'
import comEffects from './health/Effects'
import comGeneric from './health/Generic'

import comCheck from './common/Check'

import 'video.js/dist/video-js.css'
 
import { videoPlayer } from 'vue-video-player'

export default {

	props: ['section'],

	data: function() {

		return {
			step: 1,
			spot: 'spine',
			is: {
				video: false,
				image: false
			}
		}

	},

	components: {
		videoPlayer,
		'com-section': comSection,
		'com-inside': comInside,
		'com-chance': comChance,
		'com-effects': comEffects,
		'com-generic': comGeneric,
		'com-check': comCheck
	},

	computed: {

		patientSteps: function() {

			return this.section.steps || []

		},

		populationImage: function() {

			return require('@/assets/aid/health/rate.png')

		},

		insideImage: function() {

			return require('@/assets/aid/health/inside2.gif')

		}

	},

	methods: {

		onMedia: function(key) {

			this.is.video = key

		},

		onImage: function(src) {

			this.is.image = src

		},

		onModalClose: function() {

			this.is.video = false
			this.is.image = false

		},

		onNext: function() {

			this.step++

		},

		onSpotClick: function(value) {

			this.spot = value

		}

	}
	
}

</script>

<style scoped>

.health {
	width: 100%;
	height: 594px;
	display: flex;
}

.is-patient .health {
	height: auto;
	flex-direction: column;
}

.is-patient .health-sections {
	flex-grow: 0;
}


.health-skeleton {
	width: 259px;
	height: 610px;
	background-image: url(~@/assets/aid/risk/skeleton.svg);
	flex-shrink: 0;
}

.health-skeleton-spot {
	position: absolute;
	transform: translate(-50%, -50%);
	width: 32px;
	height: 32px;
	background-color: #FECC66;
	mix-blend-mode: multiply;
	border-radius: 16px;
	transition: all 100ms linear;
	opacity: 0;
}

.health-skeleton-spot.is-visible {
	opacity: 1;
}

.health-skeleton-spot.is-arm {
	left: 203px;
	top: 170px;
}

.health-skeleton-spot.is-wrist {
	left: 230px;
	top: 308px;
}

.health-skeleton-spot.is-spine {
	left: 140px;
	top: 207px;
}

.health-skeleton-spot.is-hip {
	left: 178px;
	top: 308px;
}

.health-skeleton-spot.is-pelvis {
	left: 128px;
	top: 308px;
}

.health-sections {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
}

.health-gap {
	flex-grow: 1;
}

.health-message {
	border-radius: 32px;
	background-color: #F8A533;
	min-height: 148px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 32px 32px 32px 148px;
}

.health-message-icon {
	width: 84px;
	height: 84px;
	background-color: #fff;
	border-radius: 42px;
	position: absolute;
	left: 32px;
	top: 32px;
	background-image: url(~@/assets/aid/health/icon.cross.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.is-patient .health-message-icon {
	background-image: url(~@/assets/aid/health/icon.cross.patient.svg);
}

.health-message-title {
	color: #343434;
	font-size: 20px;
	margin-bottom: 16px;
	font-weight: 600;
}

.health-video {
	position: absolute;
	z-index: 10000;
	background-color: rgba(255, 255, 255, 0.95);
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: -24px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.health-video video {
	max-width: 600px;
}

.video-player {
	max-width: 600px;
	width: 100%;
	height: auto;
}

.video-player >>> .video-js {
	background-color: #fff;
}

.health-video-close {
	position: absolute;
	right: 24px;
	top: 64px;
	width: 42px;
	margin-top: -48px;
	background-color: #F8A533;
	border-radius: 21px;
	height: 42px;
	cursor: pointer;
	background-image: url(~@/assets/aid/improve/icon.close.svg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
}


</style>

<style>

.health-modal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 10000;
	display: flex;
	justify-content: center;
	align-items: center;
}

.health-modal-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.6);
}

.health-modal-panel {
	position: relative;
	background-color: #fff;
	border-radius: 16px;
	max-width: 800px;
	width: 90%;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
}

.health-modal-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 24px;
	border-bottom: 1px solid #eee;
}

.health-modal-title {
	font-size: 18px;
	font-weight: 600;
	color: #343434;
}

.health-modal-close {
	width: 36px;
	height: 36px;
	border-radius: 18px;
	border: none;
	background-color: #f0f0f0;
	font-size: 20px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #343434;
	flex-shrink: 0;
}

.health-modal-close:hover {
	background-color: #e0e0e0;
}

.health-modal-body {
	padding: 24px;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.health-modal-image {
	display: flex;
	justify-content: center;
	align-items: center;
}

.health-modal-image img {
	max-width: 100%;
	max-height: 70vh;
	object-fit: contain;
}

</style>